import React from 'react';
import { useRecoilValue } from 'recoil';

import useModal from '@/hooks/useModal';
import InAAsk from '@/containers/modal/InA/InAAsk';
import LoginOrNonMemberWriting from '@/containers/modal/InA/LoginOrNonMemberWriting';
import { isLoginState } from '@/recoil';
import { enrolledQuestionCnt } from '@/recoil/ina';

const useCheckQuestionEnrollState = () => {
    const { addModal, removeCurrentModal } = useModal();
    const isLogin = useRecoilValue(isLoginState);
    const todayEnrolledQuestionCnt = useRecoilValue(enrolledQuestionCnt);

    const onClickEnrollQuestion = () => {
        if (todayEnrolledQuestionCnt < 5) {
            if (isLogin) {
                addModal({
                    key: 'fullScreen',
                    props: {
                        isCloseIconOnRight: false,
                        content: <InAAsk content="" category={[]} title="" fileNames={[]} fileURLs={[]} />,
                        handleCloseModal: removeCurrentModal,
                    },
                });
            } else {
                addModal({
                    key: 'slide',
                    props: {
                        hasHeader: true,
                        title: '',
                        content: <LoginOrNonMemberWriting />,
                        handleCloseModal: removeCurrentModal,
                    },
                });
            }
        } else {
            addModal({
                key: 'popUp',
                props: {
                    type: 'confirm',
                    content: '질문은 하루에 최대 5개까지\n등록 가능합니다.\n다음 날 질문을 올려보세요.',
                    handleCloseModal: removeCurrentModal,
                    onClickConfirm: removeCurrentModal,
                },
            });
        }
    };

    return { onClickEnrollQuestion };
};

export default useCheckQuestionEnrollState;
